export default "__VITE_ASSET__9Q38kB3m__"